import { TemplatesReducerCreator } from '../types';
import fetchThemePacksReducer from './fetch-theme-packs-reducer';
import saveThemePackReducer from './save-theme-pack-reducer';
import createThemePackReducer from './create-theme-pack-reducer';
import fetchThemesAndTemplatesReducer from './fetch-themes-and-templates-reducer';
import fetchUserTemplateFavoritesReducer from './fetch-user-template-favorites-reducer';
import deleteUserTemplateFavoriteReducer from './delete-user-template-favorites-reducer';
import addUserTemplateFavoriteReducer from './add-user-template-favorite-reducer';
import deleteThemePackSyncReducer from './delete-theme-pack-sync-reducer';
import updateRefetchTemplatesCounterReducer from './update-refetch-templates-counter-reducer';
import clearTemplatesListReducer from './clear-templates-list-reducer';
import appendNewThemeReducer from './append-new-theme-reducer';
import setThemePackReducer from './set-theme-pack-reducer';
import appendFontPacksReducer from './append-font-packs-reducer';
import fetchAllGlobalTemplatesForCategoriesReducer from './fetch-all-global-templates-for-categories-reducer';
import fetchTemplateCategoriesReducer from './fetch-template-categories-reducer';
import createNewTemplateCategoryReducer from './create-new-template-category-reducer';
import deleteTemplateCategoryReducer from './delete-template-category-reducer';
import replaceTemplatesForCategoryReducer from './replace-templates-for-category-reducer';
import setFontPackReducer from './set-font-pack-reducer';
import fetchFontPacksReducer from './fetch-font-packs-reducer';

export const reducers = (create: TemplatesReducerCreator) => ({
  fetchThemePacks: fetchThemePacksReducer(create),
  saveThemePack: saveThemePackReducer(create),
  createThemePack: createThemePackReducer(create),
  fetchThemesAndTemplates: fetchThemesAndTemplatesReducer(create),
  fetchUserTemplateFavorites: fetchUserTemplateFavoritesReducer(create),
  deleteUserTemplateFavorite: deleteUserTemplateFavoriteReducer(create),
  addUserTemplateFavorite: addUserTemplateFavoriteReducer(create),
  deleteThemePackSync: deleteThemePackSyncReducer(create),
  updateRefetchTemplatesCounter: updateRefetchTemplatesCounterReducer(create),
  clearTemplatesList: clearTemplatesListReducer(create),
  appendNewTheme: appendNewThemeReducer(create),
  setThemePack: setThemePackReducer(create),
  fetchFontPacks: fetchFontPacksReducer(create),
  appendFontPacks: appendFontPacksReducer(create),
  setFontPack: setFontPackReducer(create),
  fetchAllGlobalTemplatesForCategories: fetchAllGlobalTemplatesForCategoriesReducer(create),
  fetchTemplateCategories: fetchTemplateCategoriesReducer(create),
  createNewTemplateCategory: createNewTemplateCategoryReducer(create),
  deleteTemplateCategory: deleteTemplateCategoryReducer(create),
  replaceTemplatesForCategory: replaceTemplatesForCategoryReducer(create),
});
